export default "__VITE_ASSET__CFzhYTgh__"